<template>
  <ul class="navbar-nav ml-auto pull-right">
    <li class="nav-item">
      <a href="https://ameriflex-px-production.my.connect.aws/agent-app-v2/scheduling" style="padding-right: 5px"><span class="fa fa-calendar fa-3x"></span></a>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="#" style="border: 2px solid" @click.prevent="openCcp" target="ContactControlPanel">Contact Control Panel</a>
    </li>
  </ul>
</template>

<script>
import Vue from "vue";
import _ from "lodash";

export default {
  name: "ContactControlPanel",
  data() {
    return {
      ccpUrlPX: null,
      ccpUrlPXAuth: '#',
    }
  },
  async mounted() {
    await this.initCCP();
  },
  methods: {
    openCcp() {
      window.open(this.ccpUrlPX, 'ContactControlPanel', `resizable=0,scrollbars=0,menubar=0,location=0,height=465px,width=320px,noopener,noreferrer`);
    },
    async initCCP() {
      const { ccpUrlPX, ccpUrlPXAuth } = await romeApi.get('/config/appsettings?keys=CCPUrlPX&keys=CCPUrlPXAuth');
      this.ccpUrlPX = ccpUrlPX;
      this.ccpUrlPXAuth = ccpUrlPXAuth;
    }

  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/shared/ContactControlPanel.vue